import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from '@env/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { AppFeatures, appReducers, metaReducers, runtimeChecks } from './core.state';
import { SettingsEffects, settingsReducer } from './stores/settings';
import { FileAuthService, httpInterceptorProviders } from './services';

export function tokenGetter() {
  const authService = inject(FileAuthService);
  return authService.getToken();
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `${environment.i18nPrefix}/assets/i18n/`, '.json');
}

export const coreProviders = [
  importProvidersFrom(
    BrowserModule,
    CommonModule,
    JwtModule.forRoot({ config: { tokenGetter } }),
    TranslateModule.forRoot({ loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] } }),
    MatSnackBarModule,
    MatDialogModule
  ),
];

export const storeProviders = [
  provideStore(appReducers, { metaReducers, runtimeChecks }),
  provideHttpClient(withInterceptors(httpInterceptorProviders), withInterceptorsFromDi()),
  provideState(AppFeatures.SETTINGS, settingsReducer),
  provideEffects([SettingsEffects]),
  environment.production ? [] : provideStoreDevtools({ name: 'Targem AI Trainer' })
];
